import { createPrefetchableAsyncPaginatedDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getFirstPageData, getNextPageData } from './api';

export const {
	Context: TopicPagePaginatedPetitionUpdatesDataContext,
	Provider: TopicPagePaginatedPetitionUpdatesDataContextProvider,
	useContext: useTopicPagePaginatedPetitionUpdatesData,
	useAsyncData: useTopicPagePaginatedPetitionUpdatesDataFromApi,
	prefetchAsyncData: prefetchTopicPagePaginatedPetitionUpdatesDataFromApi,
} = createPrefetchableAsyncPaginatedDataContext({
	name: 'TopicPagePaginatedPetitionUpdatesDataContext',
	dataProperty: 'petitionUpdatesPaginatedData',
	getFirstPageData,
	getNextPageData,
	getUniqueId: (slug) => slug,
	hookDeps: (slug) => [slug],
	errorHandler: pageDataErrorHandler(),
});
